module.exports = __webpack_public_path__ + "static/media/GRAPHIC.33e17516.png";